var _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _path27, _path28, _rect13, _rect14, _rect15, _rect16, _rect17, _path29, _path30, _path31, _path32, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCotatoCharacterFront(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 294,
    height: 254,
    viewBox: "0 0 294 254",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8223 56.1328H139.182V64.127H148.867V212.056H139.182V212.146H138.578V220.294L49.6973 220.294V212.146H39.8223L39.8223 203.995H29.9473V64.2812H39.8223L39.8223 56.1328ZM20.0694 80.584H29.9443V179.548H20.0694V80.584ZM20.0684 109.689H10.1934V171.396H20.0684V109.689ZM168.241 196.065V171.076H178.438V131.096H168.241V111.105H158.046V80.1209H148.869V204.061H158.046V196.065H168.241ZM59.5693 220.295V228.445L128.698 228.445V220.295H59.5693Z",
    fill: "#D59F52"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 128.466,
    y: 108.223,
    width: 21.0215,
    height: 34.2572,
    fill: "#1A1918"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118.507 31.1426H60.6646V39.2925H118.507V31.1426Z",
    fill: "#1A1918"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M128.383 228.048H59.2538V236.055H128.383V228.048Z",
    fill: "#1A1918"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9447 47.1349H39.7676V56.1306H49.3782L48.9447 47.1349Z",
    fill: "#1A1918"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M128.383 47.4425H138.258V56.1306H128.383V47.4425Z",
    fill: "#1A1918"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M118.507 39.2925H128.383V47.4425H118.507V39.2925Z",
    fill: "#1A1918"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9447 39.2925H60.6646V47.4425L48.9447 47.1349V39.2925Z",
    fill: "#1A1918"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7676 56.1306H29.6271V64.1267H39.7676V56.1306Z",
    fill: "#1A1918"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M138.258 56.1306H148.134V64.1267H138.258V56.1306Z",
    fill: "#1A1918"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6271 64.1267H19.7515V80.0422H29.6271V64.1267Z",
    fill: "#1A1918"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7515 80.0422H9.87589V109.149H19.7515V80.0422Z",
    fill: "#1A1918"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M148.134 64.1267H158.01V80.119H148.134V64.1267Z",
    fill: "#1A1918"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87589 109.149H0.000289917V170.856H9.87589V109.149Z",
    fill: "#1A1918"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M168.247 80.119H158.01V111.478H168.247V80.119Z",
    fill: "#1A1918"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6271 179.006H19.7515V203.06H29.6271V179.006Z",
    fill: "#1A1918"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M168.247 170.856H178.443V195.064H168.247V170.856Z",
    fill: "#1A1918"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M168.247 111.478H178.443V131.27H168.247V111.478Z",
    fill: "#1A1918"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5026 203.06H29.6271V211.606H39.5026V203.06Z",
    fill: "#1A1918"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7515 170.856H9.87589V179.006H19.7515V170.856Z",
    fill: "#1A1918"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M148.873 204.059H158.01V212.056H148.873V204.059Z",
    fill: "#1A1918"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M158.01 195.064H168.247V204.059H158.01V195.064Z",
    fill: "#1A1918"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9447 211.606H39.5026V220.052H48.9447V211.606Z",
    fill: "#1A1918"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M138.676 212.056H148.873V220.052H138.676V212.056Z",
    fill: "#1A1918"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2538 220.052H48.9447V228.048H59.2538V220.052Z",
    fill: "#1A1918"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M128.383 220.052H138.676V228.048H128.383V220.052Z",
    fill: "#1A1918"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M168.247 131.27H178.443V170.856H168.247V131.27Z",
    fill: "#1A1918"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 52.9443,
    y: 106.666,
    width: 21.0215,
    height: 34.2572,
    fill: "#1A1918"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 63.0654,
    y: 114.451,
    width: 10.9,
    height: 14.0143,
    fill: "#F7F4F0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 138.587,
    y: 114.451,
    width: 10.9,
    height: 14.0143,
    fill: "#F7F4F0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 7.78573,
    height: 9.34288,
    transform: "matrix(-1 0 0 1 89.5361 145.596)",
    fill: "#1A1918"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 7.00716,
    height: 8.5643,
    transform: "matrix(-1 0 0 1 124.572 146.375)",
    fill: "#1A1918"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 28.3894,
    height: 7.25954,
    transform: "matrix(-1 0 0 1 78.998 237.094)",
    fill: "#B17C31"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 24.4722,
    height: 6.99664,
    transform: "matrix(-1 0 0 1 141.734 237.045)",
    fill: "#B17C31"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 28.5509,
    height: 7.99615,
    transform: "matrix(-1 0 0 1 117.264 155.084)",
    fill: "#1A1918"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 28.5509,
    height: 8.99567,
    transform: "matrix(-1 0 0 1 78.5146 228.049)",
    fill: "#1A1918"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 27.5312,
    height: 8.99567,
    transform: "matrix(-1 0 0 1 78.5146 244.041)",
    fill: "#1A1918"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 26.5115,
    height: 8.99567,
    transform: "matrix(-1 0 0 1 143.774 244.041)",
    fill: "#1A1918"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.503 39.293H60.6603V47.1348H48.938V56.1305H60.6673V63.7417H111.456V56.1305H128.473V47.1348H118.503V39.293ZM95.9375 63.7422H60.6676V71.8921H95.9375V63.7422Z",
    fill: "#EBBA77"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.7654 56.1328H48.9425V101.111H39.7654V56.1328ZM29.5685 64.1288H39.7652V179.009H49.3751V187.157H77.59V195.307H39.7652V195.307H87.465V203.457H39.4978V203.062H29.5685V179.008H19.748V80.0449H29.5685V64.1288ZM19.7461 109.152H9.87122V170.859H19.7461V109.152ZM97.3429 203.457V211.059H128.478V203.063H138.672V195.067L158.046 195.067V204.062H148.871V212.058H138.673V220.055L128.48 220.054V228.051H59.1417V220.054L48.9416 220.055V211.607H39.5002L39.5002 203.457H97.3429ZM168.244 195.066L168.244 187.07H138.674V195.066H168.244Z",
    fill: "#B17C31"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 8.1574,
    height: 24.988,
    transform: "matrix(-1 0 0 1 57.1016 228.049)",
    fill: "#1A1918"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 8.1574,
    height: 23.9885,
    transform: "matrix(-1 0 0 1 80.5557 229.051)",
    fill: "#1A1918"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 7.13772,
    height: 24.988,
    transform: "matrix(-1 0 0 1 143.774 228.049)",
    fill: "#1A1918"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 7.13772,
    height: 23.9885,
    transform: "matrix(-1 0 0 1 124.401 229.051)",
    fill: "#1A1918"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 26.5115,
    height: 8.99567,
    transform: "matrix(-1 0 0 1 143.774 228.049)",
    fill: "#1A1918"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.912 13.6484H42.5012V20.4718H103.912V13.6484ZM148.262 70.5117H130.066V77.334H92.5391V84.1562H64.1101V77.3351H92.5382V70.5117H8.38281V77.3351H15.209V84.1562V84.1574V90.9797H35.6792V84.1574H64.1084V90.9784H49.3243V97.8018H142.578V90.9797H180.106V84.1562H173.283V77.334H148.262V70.5117ZM127.793 40.9395H127.795V47.7629H15.209V40.9395H22.0303V27.2949H28.8535V20.4727H120.97V27.2949H127.793V40.9395ZM134.619 47.7656H15.209V55.7263H134.619V47.7656ZM56.1484 97.8027H135.755V104.626H128.931V111.448H62.9717V104.626H56.1484V97.8027ZM78.8924 111.451H114.147V118.275H78.8924V111.451ZM134.616 55.7268H8.38281V70.5109H134.616V55.7268Z",
    fill: "#235DD1"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0324 40.9434H15.209V90.9817H22.0324V90.9805H28.8537V90.9789H35.6769V84.1554H64.1076V77.332H35.6769H35.6768H28.8537V69.373H22.0324V40.9434ZM8.38281 55.7266H15.2062V77.334H8.38281V55.7266ZM157.36 97.8066H190.34V104.63H157.36V97.8066ZM49.3243 90.9826H69.7945V97.8061H49.3243V90.9826ZM76.6187 97.8066H56.1484V104.63H62.9715V111.452H78.8926V118.273H114.147V111.449H91.4023V104.629H76.6187V97.8066ZM122.108 104.629H128.931V111.452H122.108V104.629Z",
    fill: "#183A7E"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.964 13.6484H97.0821V20.4718H120.964V13.6484ZM109.594 20.4727H138.025V27.2949H144.849V47.7656H151.672V70.5103H144.849V70.5099H120.967V70.5097H114.144V70.5109H92.5361V63.6875H114.144V53.4512H120.967V27.2961H109.594V20.4727ZM92.5345 70.5117H81.1621V77.3351H92.5345V70.5117ZM131.201 90.9784H142.574V97.8018H131.201V90.9784ZM135.75 97.8027H124.378V104.626H135.75V97.8027ZM197.161 90.9797V84.1562H190.336V77.334H176.689V70.5117H158.494L158.494 77.334H152.807V84.1562H142.574V90.9797H197.161Z",
    fill: "#3270ED"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.459 0.00390625H57.2831V6.82732H108.459V0.00390625ZM42.499 6.82812H120.968V13.6504H138.025V20.4738H120.967V13.6515H42.499V6.82812ZM28.8516 13.6504H42.4984V20.4738H28.8516V13.6504ZM28.8527 20.4746H22.0293V27.2949H15.2061V40.9417H22.0295V27.298H28.8527V20.4746ZM49.3224 90.9824H42.499V97.8058H49.3224V90.9824ZM49.3231 97.8069H56.1466V104.63H49.3231V97.8069ZM135.754 97.8066H142.577V104.63H135.754V97.8066ZM157.36 97.8066H150.537V104.63H157.36V97.8066ZM62.9699 104.633H56.1465V111.456H62.9666V118.278H78.8879V111.455H62.9699V104.633ZM135.75 104.633H128.927V111.455H114.146V118.278H130.068V111.456H135.75V104.633ZM203.988 90.9824H142.577V97.8058H203.988V90.9824ZM78.8906 118.275H114.145V125.099H78.8906V118.275ZM144.847 20.4746H138.023V27.298H144.847V20.4746ZM190.336 77.3359H197.159V84.1593H190.336V77.3359ZM203.986 84.1582H197.162V90.9816H203.986V84.1582ZM190.336 97.8069H197.159V104.63H190.336V97.8069ZM190.34 104.633H157.36V111.456H190.34V104.633ZM35.6763 90.9824H15.2061V97.8058H35.6763V90.9824ZM35.6758 84.1582H64.1067V90.9816H35.6758V84.1582ZM92.5383 77.3359H64.1074V84.1593H92.5383V77.3359ZM92.5371 70.5098H151.673V47.7676H158.496V70.5098H158.497V77.3332H92.5371V70.5098ZM176.695 63.6895H158.499V70.5129H176.69V77.3332H190.337V70.5098H176.695V63.6895ZM8.38379 40.9434H15.2072V55.7274H8.38379V40.9434ZM15.2072 76.1973H8.38379V90.9813H15.2072V76.1973ZM8.38103 55.7285H1.55762V77.336H8.38103V55.7285ZM151.674 27.2949H144.851V47.7652H151.674V27.2949Z",
    fill: "#1A1918"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 149.486,
    y: 98.1016,
    width: 10.1214,
    height: 22.5786,
    fill: "#D59F52"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 175.959,
    y: 131.578,
    width: 13.2357,
    height: 45.9358,
    fill: "#1A1918"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 159.609,
    y: 98.1016,
    width: 8.5643,
    height: 22.5786,
    fill: "#1A1918"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 168.173,
    y: 131.578,
    width: 10.1214,
    height: 45.9358,
    fill: "#D59F52"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    width: 4.57887,
    height: 4.57887,
    transform: "matrix(3.69127e-08 -1 -1 -3.69127e-08 256.378 105.707)",
    fill: "#61DAFB"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    width: 4.57887,
    height: 4.57887,
    transform: "matrix(-3.69127e-08 1 1 3.69127e-08 234.117 175.822)",
    fill: "#61DAFB"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    width: 8.10322,
    height: 4.58008,
    transform: "matrix(-3.69127e-08 1 1 3.69127e-08 256.87 149.396)",
    fill: "#61DAFB"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    width: 8.10322,
    height: 4.58008,
    transform: "matrix(3.69127e-08 -1 -1 -3.69127e-08 233.618 132.129)",
    fill: "#61DAFB"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    width: 9.15956,
    height: 4.57978,
    transform: "matrix(-3.69127e-08 1 1 3.69127e-08 261.458 140.234)",
    fill: "#61DAFB"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    width: 8.10322,
    height: 4.58008,
    transform: "matrix(3.69127e-08 -1 -1 -3.69127e-08 229.042 140.234)",
    fill: "#61DAFB"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    width: 8.10322,
    height: 4.58008,
    transform: "matrix(-3.69127e-08 1 1 3.69127e-08 266.033 124.029)",
    fill: "#61DAFB"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    width: 8.10322,
    height: 4.58008,
    transform: "matrix(3.69127e-08 -1 -1 -3.69127e-08 224.455 157.5)",
    fill: "#61DAFB"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    width: 22.9004,
    height: 4.58008,
    transform: "matrix(-3.69127e-08 1 1 3.69127e-08 270.619 101.125)",
    fill: "#61DAFB"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    width: 22.9004,
    height: 4.58008,
    transform: "matrix(3.69127e-08 -1 -1 -3.69127e-08 219.881 180.398)",
    fill: "#61DAFB"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    width: 4.57887,
    height: 4.57887,
    transform: "matrix(3.69127e-08 -1 -1 -3.69127e-08 251.803 110.285)",
    fill: "#61DAFB"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    width: 4.57887,
    height: 4.57887,
    transform: "matrix(-3.69127e-08 1 1 3.69127e-08 238.698 171.238)",
    fill: "#61DAFB"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    width: 4.57887,
    height: 4.57887,
    transform: "matrix(3.69127e-08 -1 -1 -3.69127e-08 247.215 114.865)",
    fill: "#61DAFB"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    width: 4.57887,
    height: 4.57887,
    transform: "matrix(-3.69127e-08 1 1 3.69127e-08 243.273 166.66)",
    fill: "#61DAFB"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    width: 4.57887,
    height: 4.57887,
    transform: "matrix(3.69127e-08 -1 -1 -3.69127e-08 242.642 119.445)",
    fill: "#61DAFB"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    width: 4.57887,
    height: 4.57887,
    transform: "matrix(-3.69127e-08 1 1 3.69127e-08 247.854 162.082)",
    fill: "#61DAFB"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    width: 4.58008,
    height: 19.025,
    transform: "matrix(3.69127e-08 -1 -1 -3.69127e-08 252.652 124.029)",
    fill: "#61DAFB"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    width: 4.58008,
    height: 18.3203,
    transform: "matrix(3.69127e-08 -1 -1 -3.69127e-08 229.042 128.609)",
    fill: "#61DAFB"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    width: 4.57887,
    height: 4.57887,
    transform: "matrix(3.69127e-08 -1 -1 -3.69127e-08 210.72 133.188)",
    fill: "#61DAFB"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    width: 4.57887,
    height: 4.57887,
    transform: "matrix(3.69127e-08 -1 -1 -3.69127e-08 206.138 137.766)",
    fill: "#61DAFB"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    width: 4.57887,
    height: 4.57887,
    transform: "matrix(3.69127e-08 -1 -1 -3.69127e-08 288.938 137.766)",
    fill: "#61DAFB"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    width: 5.98974,
    height: 4.58039,
    transform: "matrix(3.69127e-08 -1 -1 -3.69127e-08 201.556 143.758)",
    fill: "#61DAFB"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 288.938,
    y: 143.758,
    width: 5.98974,
    height: 4.58039,
    transform: "rotate(-90 288.938 143.758)",
    fill: "#61DAFB"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    width: 4.57887,
    height: 4.57887,
    transform: "matrix(3.69127e-08 -1 -1 -3.69127e-08 206.138 148.338)",
    fill: "#61DAFB"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 284.357,
    y: 148.338,
    width: 4.57887,
    height: 4.57887,
    transform: "rotate(-90 284.357 148.338)",
    fill: "#61DAFB"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    width: 4.57887,
    height: 4.57887,
    transform: "matrix(3.69127e-08 -1 -1 -3.69127e-08 284.357 133.188)",
    fill: "#61DAFB"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    width: 4.58008,
    height: 18.3203,
    transform: "matrix(3.69127e-08 -1 -1 -3.69127e-08 279.789 128.609)",
    fill: "#61DAFB"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    width: 4.57887,
    height: 4.57887,
    transform: "matrix(-3.69127e-08 1 1 3.69127e-08 252.435 157.5)",
    fill: "#61DAFB"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 256.524,
    y: 96.5449,
    width: 14.0926,
    height: 4.58008,
    fill: "#61DAFB"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 233.964,
    y: 184.982,
    width: 14.0926,
    height: 4.58008,
    transform: "rotate(180 233.964 184.982)",
    fill: "#61DAFB"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 234.117,
    y: 105.707,
    width: 4.57887,
    height: 4.57887,
    transform: "rotate(-90 234.117 105.707)",
    fill: "#61DAFB"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 256.378,
    y: 175.822,
    width: 4.57887,
    height: 4.57887,
    transform: "rotate(90 256.378 175.822)",
    fill: "#61DAFB"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 233.618,
    y: 149.396,
    width: 8.10322,
    height: 4.58008,
    transform: "rotate(90 233.618 149.396)",
    fill: "#61DAFB"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 256.87,
    y: 132.129,
    width: 8.10322,
    height: 4.58008,
    transform: "rotate(-90 256.87 132.129)",
    fill: "#61DAFB"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 229.042,
    y: 140.234,
    width: 9.15956,
    height: 4.57978,
    transform: "rotate(90 229.042 140.234)",
    fill: "#61DAFB"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 261.458,
    y: 140.234,
    width: 8.10322,
    height: 4.58008,
    transform: "rotate(-90 261.458 140.234)",
    fill: "#61DAFB"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 224.455,
    y: 124.029,
    width: 8.45498,
    height: 4.57978,
    transform: "rotate(90 224.455 124.029)",
    fill: "#61DAFB"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 229.042,
    y: 152.916,
    width: 4.58008,
    height: 18.3203,
    transform: "rotate(90 229.042 152.916)",
    fill: "#61DAFB"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    width: 4.58008,
    height: 19.3773,
    transform: "matrix(-3.69127e-08 1 1 3.69127e-08 260.403 152.916)",
    fill: "#61DAFB"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 210.72,
    y: 148.338,
    width: 4.57887,
    height: 4.57887,
    transform: "rotate(90 210.72 148.338)",
    fill: "#61DAFB"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    width: 4.57887,
    height: 4.57887,
    transform: "matrix(-3.69127e-08 1 1 3.69127e-08 279.789 148.338)",
    fill: "#61DAFB"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 266.033,
    y: 157.5,
    width: 8.10322,
    height: 4.58008,
    transform: "rotate(-90 266.033 157.5)",
    fill: "#61DAFB"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 219.881,
    y: 101.125,
    width: 22.9004,
    height: 4.58008,
    transform: "rotate(90 219.881 101.125)",
    fill: "#61DAFB"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 270.619,
    y: 180.398,
    width: 22.9004,
    height: 4.58008,
    transform: "rotate(-90 270.619 180.398)",
    fill: "#61DAFB"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 238.698,
    y: 110.285,
    width: 4.57887,
    height: 4.57887,
    transform: "rotate(-90 238.698 110.285)",
    fill: "#61DAFB"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 251.803,
    y: 171.238,
    width: 4.57887,
    height: 4.57887,
    transform: "rotate(90 251.803 171.238)",
    fill: "#61DAFB"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 243.273,
    y: 114.865,
    width: 4.57887,
    height: 4.57887,
    transform: "rotate(-90 243.273 114.865)",
    fill: "#61DAFB"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 247.215,
    y: 166.66,
    width: 4.57887,
    height: 4.57887,
    transform: "rotate(90 247.215 166.66)",
    fill: "#61DAFB"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 247.854,
    y: 119.445,
    width: 4.57887,
    height: 4.57887,
    transform: "rotate(-90 247.854 119.445)",
    fill: "#61DAFB"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 242.642,
    y: 162.082,
    width: 4.57887,
    height: 4.57887,
    transform: "rotate(90 242.642 162.082)",
    fill: "#61DAFB"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 252.435,
    y: 124.029,
    width: 4.57887,
    height: 4.57887,
    transform: "rotate(-90 252.435 124.029)",
    fill: "#61DAFB"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 252.652,
    y: 157.5,
    width: 4.58008,
    height: 19.025,
    transform: "rotate(90 252.652 157.5)",
    fill: "#61DAFB"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    width: 14.0926,
    height: 4.58008,
    transform: "matrix(-1 0 0 1 233.964 96.5449)",
    fill: "#61DAFB"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    width: 14.0926,
    height: 4.58008,
    transform: "matrix(1 0 0 -1 256.524 184.982)",
    fill: "#61DAFB"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 239.261,
    y: 134.246,
    width: 13.0356,
    height: 13.0356,
    fill: "#61DAFB"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 237.503,
    y: 136.359,
    width: 16.5588,
    height: 8.80785,
    fill: "#61DAFB"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 242.423,
    y: 132.129,
    width: 6.69397,
    height: 17.2634,
    fill: "#61DAFB"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 210.994,
    y: 73.1855,
    width: 4.44352,
    height: 4.44352,
    transform: "rotate(45 210.994 73.1855)",
    fill: "#61DAFB"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    width: 4.44352,
    height: 4.44352,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 221.921 192.307)",
    fill: "#61DAFB"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 225.559,
    y: 73.1855,
    width: 8.48651,
    height: 8.48651,
    transform: "rotate(45 225.559 73.1855)",
    fill: "#61DAFB"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    width: 8.48651,
    height: 8.48651,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 210.994 193.086)",
    fill: "#61DAFB"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    width: 16.3585,
    height: 16.3585,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 242.802 200.094)",
    fill: "#61DAFB"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 68.5156,
    y: 26.4707,
    width: 15.5715,
    height: 5.45001,
    fill: "#D9D9D9"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 68.5156,
    y: 38.1484,
    width: 15.5715,
    height: 5.45001,
    fill: "#D9D9D9"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 63.0654,
    y: 31.9219,
    width: 5.45001,
    height: 26.4715,
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCotatoCharacterFront);
export default __webpack_public_path__ + "static/media/cotato_character_front.e16e41fa60255bafe91487360480adc5.svg";
export { ForwardRef as ReactComponent };